var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2071 5.29289C12.5976 5.68342 12.5976 6.31658 12.2071 6.70711L7.70712 11.2071C7.51176 11.4025 7.24428 11.5083 6.96815 11.4995C6.69201 11.4907 6.43182 11.368 6.2493 11.1606L4.2493 8.8879C3.88444 8.47329 3.92478 7.84141 4.33938 7.47656C4.75399 7.1117 5.38587 7.15204 5.75073 7.56664L7.04659 9.03921L10.7929 5.29289C11.1834 4.90237 11.8166 4.90237 12.2071 5.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.c11c7d0007ed17b13e9ba66489815c15.svg";
export { ForwardRef as ReactComponent };